import { Stack, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { Button } from '@/components/navigation/NavigationIntroScreen/components/Popup/styles';
import { CornerUpRitghtIcon, SmartphoneIcon } from '@/components/navigation/NavigationIntroScreen/components/Popup/Icons';
import { navigationTranslationState } from '../../../../../../store';

export const ButtonsContainer = ({ isMobile, contentLoaded, onConfirm, setSharePopupOpen, sharingEnabled, rtl }) => {
  const translation = useRecoilValue(navigationTranslationState);

  return (
    <Stack
      id="buttons-container"
      sx={{
        position: isMobile ? 'absolute' : 'sticky',
        bottom: 0,
        left: isMobile ? 0 : undefined,
        background: '#fff',
        width: isMobile ? '100%' : 'auto',
        p: isMobile ? '14px 12px 30px 12px' : '14px',
        zIndex: 9999,
      }}
    >
      <Button
        disabled={!contentLoaded}
        onClick={onConfirm}
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', direction: rtl ? 'rtl' : 'ltr', height: '40px' }}
      >
        <CornerUpRitghtIcon style={{ width: '20px', height: '20px' }} />
        <Typography sx={{ direction: rtl ? 'rtl' : 'ltr', fontWeight: rtl ? 500 : 600 }}>{translation.navGetDirections || 'Get directions'}</Typography>
      </Button>
      {sharingEnabled && (
        <Button
          onClick={() => setSharePopupOpen(true)}
          disabled={!contentLoaded}
          style={{
            display: isMobile ? 'none' : 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            background: '#FFFFFF',
            color: '#2055FF',
            marginTop: '10px',
            border: '1px solid #D0D5DD',
            direction: rtl ? 'rtl' : 'ltr',
            height: '40px',
          }}
        >
          <SmartphoneIcon style={{ width: '20px', height: '20px' }} />
          <Typography sx={{ direction: rtl ? 'rtl' : 'ltr', fontWeight: rtl ? 500 : 600 }}>{translation.navShareToPhone || 'Share to your phone'}</Typography>
        </Button>
      )}
    </Stack>
  );
};
